import { trackEvent } from '../../../_common/client/tracking';
import { ReportReviewSheetService } from './report-review-sheet-service';

export class ReportReviewService {
    constructor(private reportReviewSheetService: ReportReviewSheetService) {}

    public initReportButton(componentRootElement: HTMLElement): void {
        const reviewPosition = this.calculateReviewPositionFromHtml(componentRootElement);
        const reviewId = this.readReviewIdFromHtml(componentRootElement);

        if (reviewPosition === null || reviewId === null) {
            return;
        }

        this.addClickListenerToReportReviewButton(componentRootElement, reviewId, reviewPosition);
    }

    private addClickListenerToReportReviewButton(componentRootElement: HTMLElement, reviewId: string, reviewPosition: number) {
        const reportReviewButton = componentRootElement.querySelector('.js_pdp_cr-item_report-review-link');
        reportReviewButton?.addEventListener('click', () => this.handleReportButtonClick(reviewId, reviewPosition));
    }

    private readReviewIdFromHtml(componentRootElement: HTMLElement) {
        return componentRootElement.dataset.reviewId ?? null;
    }

    private handleReportButtonClick(reviewId: string, reviewPosition: number) {
        this.trackEventReportOpen(reviewPosition);
        this.reportReviewSheetService.openSheet(reviewId, reviewPosition);
    }

    private trackEventReportOpen(reviewPosition: number) {
        trackEvent({
            review_ReportReview: 'open',
            review_SingleReviewPosition: reviewPosition,
        });
    }

    private calculateReviewPositionFromHtml(componentRootElement: HTMLElement) {
        const reviewItemListIndexNumber = this.convertToInt(componentRootElement.dataset.reviewItemListIndex);
        if (reviewItemListIndexNumber === null) {
            return null;
        }
        return reviewItemListIndexNumber + 1;
    }

    private convertToInt(myString: string | null | undefined) {
        if (myString == null || isNaN(parseInt(myString))) {
            return null;
        }
        return parseInt(myString);
    }
}
